var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.version === 'v2')?_c('div',[_c('SpinGift')],1):_vm._e(),(_vm.version === 'v3')?_c('div',[_c('SpinCarousel')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }